import { $ } from "./imports";

const acordeon = () => {
    let $acordeon = $('.accordion'); 
    if($acordeon.length > 0){
        // Por cada item
        $acordeon.find('.accordion-item').each(function(indice, item){
            let $btn = $(item).find('.accordion-button');
            let $collapse = $(item).find('.accordion-collapse');

            // Añadimos id
            $btn.attr({
                'data-bs-target': `#acordeon-item-${indice}`,
                'aria-controls' : `acordeon-item-${indice}`
            });

            $collapse.attr('id', `acordeon-item-${indice}`);

            // Si es el primer item, se muestra
            if(indice === 0){
                $btn.removeClass('collapsed');
                $btn.attr('aria-expanded', 'true');
                $collapse.addClass('show');
            }
        });
    }
};

export default acordeon;